<template>
    <kiosk-layout>
        <!-- Cloning Targets -->
        <div class="card card-default">
            <div class="card-header">
                <a
                    style="color: black; display: block"
                    @click.prevent="showCloningTargets = !showCloningTargets"
                    role="button"
                >
                    <div class="vx-flex vx-items-center">
                        <span>Cloning Targets</span>
                    </div>
                </a>
            </div>

            <div v-if="showCloningTargets">
                <kiosk-cloning-targets></kiosk-cloning-targets>
            </div>
        </div>

        <!-- Clone teams -->
        <kiosk-clone-teams></kiosk-clone-teams>
    </kiosk-layout>
</template>

<script setup>
import KioskLayout from '~/components/kiosk/KioskLayout.vue';

import KioskCloneTeams from './KioskCloneTeams.vue';
import KioskCloningTargets from './KioskCloningTargets.vue';
import { ref } from 'vue';
const showCloningTargets = ref(false);
</script>
